module.exports = __webpack_public_path__ + "lz.worker.js"